import React from 'react';
import { useQuickEstimate } from '../../../hooks/estimation';
import { QUICK_STEPS } from './config/QuickSteps';

export const QuickEstimate: React.FC = () => {
  const {
    currentStep,
    formData,
    error,
    handleNext,
    handleBack,
    handleStepDataChange,
    handleReset
  } = useQuickEstimate();

  const getCurrentStepComponent = () => {
    const step = QUICK_STEPS.find(s => s.id === currentStep);
    if (!step) return null;

    const StepComponent = step.component;
    const stepProps = {
      value: formData,
      onChange: handleStepDataChange,
      onNext: handleNext,
      onBack: handleBack,
      onReset: handleReset,
      error
    };

    return <StepComponent {...stepProps} />;
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="bg-white rounded-lg shadow-lg p-6">
        {getCurrentStepComponent()}
      </div>
    </div>
  );
};

export default QuickEstimate;